import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { analyticsTrackEvent } from '../../../core/analytics';
import {
  CDP_CLICK_LEAVE_REVIEW,
  CDP_LEAVE_REVIEW_QUESTIONNAIRE,
} from '../../../core/analytics/events';
import { isSolvPartner } from '../../../core/util/location';
import { colors } from '../../../constants/colors';
import { fontSize, fontFamily } from '../../../constants/text';
import { smallerThanOrEqualTo } from '../../../core/util/styledComponents';

export const LEAVE_REVIEW_MODAL = 'leave a review modal';

const SmoothDialog = styled(Dialog)`
  -webkit-font-smoothing: antialiased;
`;

const Container = styled.div`
  padding: 20px;
  background: ${colors.white};
  display: block;
`;

const Header = styled.div`
  font-size: ${fontSize.hellaLarge};
  font-family: ${fontFamily.bold};
  color: ${colors.squid};
  text-align: center;
  margin: 0 auto;

  ${smallerThanOrEqualTo.md`
    font-size: ${fontSize.extraLarge}
  `}
`;

const FlavorHeader = styled.div`
  margin: 20px 0;
  font-size: ${fontSize.large};
  font-family: ${fontFamily.book};
  color: ${colors.greyLock};
`;

const Close = styled.div`
  width: 25px;
  height: 25px;
  position: relative;
  cursor: pointer;
  margin: 0 0 -10px auto;
  ${smallerThanOrEqualTo.md`
    margin 0 0 0 auto;
  `}

  &:before {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(45deg);
    background-color: ${colors.squid};
  }

  &:after {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(-45deg);
    background-color: ${colors.squid};
  }
`;

const QuestionnaireContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
`;

const Button = styled.div`
  border-radius: 4px;
  margin: 10px;
  width: 80%;
  max-width: 250px;
  background-color: ${colors.tangledUpInBlue};
  color: ${colors.fiveSevenNineGrey};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.default};
  padding: 10px;
  text-align: center;
  cursor: pointer;
  text-wrap: none;
  white-space: nowrap;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.25);
  transition: all 100ms ease;

  &:hover {
    color: ${colors.tangledUpInBlue};
    background-color: ${colors.fiveSevenNineGrey};
  }
`;

const Thanks = styled.div`
  font-size: ${fontSize.large};
  font-family: ${fontFamily.book};
  color: ${colors.greenHope};
  text-align: center;
`;

const buttonOptions = [
  'Quality of care',
  'Clinic staff service',
  'Wait-time',
  'Facility location and ambiance',
  'Online appointment availability',
  'Other',
];

class LeaveAReviewTestModal extends PureComponent {
  static propTypes = {
    fullScreen: PropTypes.bool,
    open: PropTypes.bool,
    location: PropTypes.object,
    onClose: PropTypes.func,
  };

  state = {
    submittedQuestionnaire: false,
  };

  componentDidMount() {
    const { location } = this.props;
    analyticsTrackEvent(CDP_CLICK_LEAVE_REVIEW, {
      isSolvPartner: isSolvPartner(location),
    });
  }

  questionnaireClick = response => {
    this.setState({ submittedQuestionnaire: true });
    analyticsTrackEvent(CDP_LEAVE_REVIEW_QUESTIONNAIRE, { response });
  };

  render = () => {
    const { onClose, open, fullScreen } = this.props;
    const { submittedQuestionnaire } = this.state;
    return (
      <SmoothDialog open={open} onClose={onClose} maxWidth="md" fullWidth fullScreen={fullScreen}>
        <Container>
          <Close onClick={onClose} />
          <Header>Coming Soon!</Header>
          <FlavorHeader>Please let us know what you want to review about:</FlavorHeader>
          {!submittedQuestionnaire ? (
            <QuestionnaireContainer>
              {buttonOptions.map(option => (
                <Button onClick={() => this.questionnaireClick(option)} key={option}>
                  {option}
                </Button>
              ))}
            </QuestionnaireContainer>
          ) : (
            <Thanks>Thanks for your feedback!</Thanks>
          )}
        </Container>
      </SmoothDialog>
    );
  };
}

export default withMobileDialog({ breakpoint: 'xs' })(LeaveAReviewTestModal);
